var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 46,
    viewBox: "0 0 200 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.59583 14.3403C1.59592 13.6101 1.83558 12.9003 2.27767 12.3209C2.71976 11.7415 3.33963 11.3247 4.04125 11.1352C4.74286 10.9457 5.48708 10.994 6.15863 11.2726C6.83018 11.5512 7.39157 12.0446 7.75586 12.6764H17.0009V16.0056H7.75586C7.39151 16.6374 6.82999 17.1309 6.1583 17.4095C5.48661 17.688 4.74225 17.7362 4.04056 17.5465C3.33886 17.3568 2.719 16.9398 2.27702 16.3602C1.83504 15.7805 1.59561 15.0705 1.59583 14.3403Z",
    fill: "#FFCE1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4394 42.6822C22.4391 42.1004 22.5912 41.5288 22.8803 41.0247C23.1694 40.5206 23.5853 40.1019 24.0864 39.8105V37.6663H15.1258V7.29025C14.3459 6.91381 13.7164 6.28229 13.3404 5.49918C12.9644 4.71607 12.8643 3.82783 13.0563 2.98001C13.2484 2.1322 13.7213 1.3751 14.3976 0.832787C15.0739 0.290475 15.9134 -0.00488281 16.7786 -0.00488281C17.6437 -0.00488281 18.4832 0.290475 19.1595 0.832787C19.8358 1.3751 20.3087 2.1322 20.5008 2.98001C20.6928 3.82783 20.5927 4.71607 20.2167 5.49918C19.8407 6.28229 19.2112 6.91381 18.4313 7.29025V34.3328H27.3919V39.8105C27.8933 40.1024 28.3095 40.5219 28.5986 41.0267C28.8877 41.5315 29.0396 42.1038 29.0389 42.6863C29.0382 43.2687 28.8851 43.8407 28.5948 44.3449C28.3046 44.849 27.8875 45.2675 27.3853 45.5583C26.8832 45.8491 26.3138 46.002 25.7343 46.0017C25.1547 46.0013 24.5855 45.8477 24.0837 45.5563C23.582 45.2649 23.1654 44.8458 22.8757 44.3414C22.5861 43.8369 22.4336 43.2647 22.4337 42.6822H22.4394Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.485 20.7046L186.143 18.3488L195.318 9.12598H200L189.414 19.7726L188.65 18.9364V20.5388L188.485 20.7046Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.588 25.3091H194.906L185.73 16.0848L188.073 13.7305L188.642 14.3023V15.889L189.428 15.0856L199.587 25.3091H199.588Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.701 25.3046H166.077L160.68 13.1285L155.286 25.3046H151.66L158.827 9.12598H162.534L169.701 25.3046Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.031 20.0026V16.6748H155.919V20.0026H166.031Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.558 23.0048V22.9791H171.26V6.82617H174.571V19.677H183.531V23.0048H171.558Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.651 9.12598H185.34V25.3046H188.651V9.12598Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.164 17.6123H130.475V25.3042H127.164V17.6123Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.546 9.29297H146.234V25.3029H149.546V9.29297Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.906 23.1683L130.438 25.3027L140.519 13.2278L137.988 11.0934L127.906 23.1683Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.722 11.0941L136.191 13.2285L146.273 25.3034L148.804 23.1689L138.722 11.0941Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.414 10.5762L140.644 13.3965H136.215L138.414 10.5762Z",
    fill: "#C62B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6081 25.2759H51.2188V21.9424H54.6081V6.41992H57.9207V6.4285L67.0647 17.381V6.41992H70.3759V22.5985H67.069V22.5414L57.9207 11.5846V25.2759H54.6081Z",
    fill: "#3E59B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.19899e-06 26.5296C9.91969e-05 25.7994 0.239754 25.0897 0.681849 24.5102C1.12394 23.9308 1.74381 23.5141 2.44542 23.3246C3.14704 23.1351 3.89126 23.1833 4.56281 23.462C5.23435 23.7406 5.79575 24.234 6.16004 24.8657H23.8565V0.622072H30.557V3.94985H27.1662V12.2279H30.5556V12.2364C31.6495 12.2364 32.6986 11.7997 33.4722 11.0223C34.2457 10.2448 34.6803 9.19043 34.6803 8.091C34.6803 6.99156 34.2457 5.93715 33.4722 5.15973C32.6986 4.38231 31.6495 3.94556 30.5556 3.94556L30.557 0.622072C32.3374 0.620959 34.0576 1.26238 35.407 2.42959C36.7564 3.5968 37.644 5.21219 37.9081 6.98173C38.1723 8.75126 37.7954 10.5573 36.8461 12.0711C35.8969 13.5849 34.4383 14.7057 32.736 15.2297L39.3611 23.1661L36.8237 25.3103L28.6838 15.5613H27.1662V28.1992H6.16004C5.79551 28.8314 5.23361 29.325 4.56149 29.6035C3.88938 29.882 3.1446 29.9298 2.44267 29.7396C1.74075 29.5493 1.12089 29.1316 0.679249 28.5513C0.237603 27.9709 -0.0011547 27.2602 4.19899e-06 26.5296Z",
    fill: "#3E59B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7906 25.2714H51.1666L45.7703 13.0953L40.3755 25.2714H36.75L43.917 9.09277H47.6236L54.7906 25.2714Z",
    fill: "#3E59B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5 19.9694V16.6416H41.0061V19.9694H50.5Z",
    fill: "#3E59B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9112 25.3034H73.6V12.4254H69.5977V9.09766H76.9112V9.11481H81.6475V9.09766C81.8296 9.09766 82.0102 9.10337 82.1894 9.11481H82.2662C84.2886 9.26984 86.178 10.1872 87.5559 11.683C88.9337 13.1789 89.6983 15.1428 89.6964 17.1812C89.6971 18.2438 89.4894 19.296 89.0852 20.2778C88.681 21.2596 88.0881 22.1516 87.3406 22.9029C86.593 23.6542 85.7054 24.2501 84.7285 24.6563C83.7517 25.0626 82.7047 25.2713 81.6475 25.2706V25.2991L76.9112 25.3034ZM76.9112 21.9742H81.6475V21.9256C82.2738 21.9366 82.8961 21.822 83.4779 21.5887C84.0598 21.3553 84.5895 21.0079 85.0363 20.5666C85.4831 20.1253 85.838 19.5989 86.0802 19.0183C86.3225 18.4377 86.4472 17.8144 86.4472 17.1848C86.4472 16.5552 86.3225 15.9319 86.0802 15.3513C85.838 14.7707 85.4831 14.2444 85.0363 13.8031C84.5895 13.3618 84.0598 13.0143 83.4779 12.781C82.8961 12.5476 82.2738 12.4331 81.6475 12.444H76.9112V21.9742Z",
    fill: "#3E59B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.1 22.5982H90.8711V7.29297H106.1V22.5982ZM94.1637 10.6022V19.289H102.807V10.6022H94.1637Z",
    fill: "#3E59B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.395 9.12598H108.084V25.3046H111.395V9.12598Z",
    fill: "#3E59B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.471 9.12598H127.16V17.2153H130.471V9.12598Z",
    fill: "#3E59B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.252 23.7279L108.844 11.2602L111.375 9.12598L121.411 21.1463L119.252 23.7265V23.7279Z",
    fill: "#3E59B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.251 23.7208L117.092 21.1334L127.122 9.12598L129.654 11.2602L119.251 23.7208Z",
    fill: "#3E59B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.86c55b024a42262080a40e15c4fe7a84.svg";
export { ForwardRef as ReactComponent };